import * as React from "react";
import * as moment from "moment";
import { Alert, Alignment, Button, Classes, Dialog, FormGroup, H5, Icon, InputGroup, Popover, ProgressBar, Tag, Tooltip } from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { IViewModel } from "mobx-utils";
import { IHistoricoNotas, newEmpresa } from "../../model";
import { AppStore } from "../../stores/AppStore";
import { EmpresaStore } from "../../stores/empresa/EmpresaStore";
import { ManifestacoesStore } from "../../stores/manifestacoes/ManifestacoesStore";
import { toast } from "react-toastify";
import { copyToClipboard } from "../../utils";
import { DateRangePicker } from "../utils/DateRangePicker";
import { MDBBtn, MDBCol, MDBDropdown, MDBDropdownItem, MDBDropdownMenu, MDBDropdownToggle, MDBRow } from "mdbreact";
import { IEmpresa, IFilter, newIFilter } from "../../model";
import { formatCnpj } from "../../utils";
import { EmpresaSelect, filterEmpresa, renderEmpresa, } from "../empresa/EmpresaSelect";
import { BootstrapTable, SearchField, TableHeaderColumn } from "react-bootstrap-table";
import Tour from "reactour";
import { api } from "../../api";
import { ResultadoStore } from "../../stores/resultados/ResultadoStore";
import LoadingModal from "../loading/LoadingModal";

const numeral = require("numeral");

interface ManifestacoesProps {
  checked?: boolean;
}

interface ManifestacoesState {
  input: string;
  date1: string;
  date2: string;
  filtro: string;
  tipo: string;
  justificativa: string;
  email: string;
  date: any;
  checked?: boolean;
  status: string;
  allCheck: string;
  check: any;
  tipo_arquivo: string;
  list: any[];
  aqui: any[];
  isTourOpen: boolean;
  isShowingMore: boolean;
}

@observer
export default class Manifestacoes extends React.Component<ManifestacoesProps, ManifestacoesState> {
  obs = observable({
    adding: false as boolean,
    imps: new Map() as Map<number, IHistoricoNotas & IViewModel<IHistoricoNotas>>,
    selectedPeriod: [] as any,
    selectedEmpresa: newEmpresa() as IEmpresa,
    filtro: "" as string,
    tipo: "" as string,
    justificativa: "" as string,
    email: "" as string,
    allCheck: "" as string,
    showingxJust: false as boolean,
    confirmarDanfe: false as boolean,
    showingSEFAZ: false as boolean,
    showingEmail: false as boolean,
    list: [] as any[],
    aqui: [] as any[],
    textFilter: "" as string,
    confirmarAlert: false as boolean,
    desconhecerAlert: false as boolean,
    naoRealizadaAlert: false as boolean,
    tipo_arquivo: "" as string,
    progressDownload: false as boolean,
    isTourOpen: false as boolean,
    testeGestaoNFes: false as boolean,
    filtro_notas: newIFilter() as IFilter,
    erros_chaves: [] as any[],
    isOpenErros: false as boolean,
    isContestar: false as boolean

  })

  constructor(props) {
    super(props);
    ManifestacoesStore.obs.imps = [];
    this.obs.isContestar = false
    this.handleViewDay();
  }

  async componentDidMount() {
    let permissao = AppStore.obs1.usuario ? AppStore.obs1.usuario.conta.teste : false;
    if (permissao) {
      this.obs.testeGestaoNFes = true;
    }

    this.setState({ isTourOpen: false });
    this.setState({ isShowingMore: false });

    AppStore.setTitle("");
    ManifestacoesStore.load();
    this.obs.selectedPeriod = AppStore.obs1.selectedPeriod;
    this.setState({ filtro: "Todos" });
    this.setState({ tipo: "NF-e" });
    this.handleDateChange(this.obs.selectedPeriod);
    this.obs.showingxJust = false;
    this.setState({ list: [] });
    this.setState({ aqui: [] });
    this.setState({ tipo_arquivo: "DANFE" });
    if (localStorage.getItem("Status")) {
      toast.success('NFE-s manifestadas com sucesso!', {});
      localStorage.removeItem("Status");
    }
    if (localStorage.getItem("StatusEmail")) {
      toast.success('E-mail enviado com sucesso!', {});
      localStorage.removeItem("StatusEmail");
    }

    await ManifestacoesStore.handldeItensProcessando();

  }

  handleCheckChange = (chave: String, cnpj_destino: String, dhemi: String) => {
    let data = { chave: chave, cnpj_destino: cnpj_destino, dhemi: dhemi }

    this.setState(state => {
      const list = state.list.push(data);
    });

  };

  handleCheckAllChange = (checked, row) => {
    if (checked) {
      this.setState({ list: [] });
      const list = [];
      this.setState({ allCheck: "Todos" });
      let items = ManifestacoesStore.getAllPages(
        ManifestacoesStore.obs.currentPage,
      )?.map((imp: IHistoricoNotas & IViewModel<IHistoricoNotas>) => {
        if (
          imp.sitnfe == "1" && imp.desconhecido == false &&
          imp.nao_realizado == false
        ) {
          let data = { chave: imp.chave, cnpj_destino: imp.cnpj_destino, dhemi: imp.dhemi }
          this.setState(state => {
            const list = state.list.push(data);
          });
        }
      });
    } else {
      this.setState({ list: [] });
    }
  };

  handlePageChange = (page: number) => {
    ManifestacoesStore.setCurrentPage(page);
    if (this.state.allCheck == "Todos") {
    }
  };

  handleCopyChave = (token: string) => {
    copyToClipboard(token);
    toast.success('Chave de Acesso Copiada', {});
  };

 /**
 * Manipula a mudança de período de emissão no componente de seleção de datas.
 *
 * Comportamento:
 * - Valida as datas recebidas para evitar valores inválidos ("Invalid date").
 * - Se não houver data inicial válida, limpa o período selecionado e zera os campos.
 * - Se não houver data final, define automaticamente como o último dia do mês da data inicial.
 * - Se houver data final mas for inválida ou anterior à inicial, também define como o último dia do mês.
 * - Garante que `selectedPeriod`, `state.date1/date2` e os campos do `ResultadoStore` fiquem sincronizados.
 *
 * @param val Par de valores retornado pelo componente de seleção de datas.
 *            - `val[0]`: Data inicial (obrigatória para definir o período).
 *            - `val[1]`: Data final (opcional; quando ausente ou inválida, é ajustada para o fim do mês).
 *
 */

  handleDateChange = (val: any) => {

    const rawStart = val?.[0] ?? null;
    const rawEnd   = val?.[1] ?? null;

    const start = moment(rawStart).startOf("day");
    if (!rawStart || !start.isValid()) {
      this.obs.selectedPeriod = [null, null] as any;
      this.setState({ date1: "", date2: "" });
      ResultadoStore.obs.date_start = null;
      ResultadoStore.obs.date_end = null;
      ResultadoStore.obs.date_referencia = null;
      return;
    }

    let end = rawEnd ? moment(rawEnd).startOf("day") : null;
    if (end && !end.isValid()) end = null;

    if (!end) {
      end = start.clone().endOf("month");
    }

    if (end.isBefore(start, "day")) {
      end = start.clone().endOf("month");
    }

    this.obs.selectedPeriod = [start.toDate(), end?.toDate()] as any;

    const dateStartStr = start.format("YYYY-MM-DD");
    const dateEndStr   = end.format("YYYY-MM-DD");

    this.setState({ date1: dateStartStr, date2: dateEndStr });

    ResultadoStore.obs.date_start = dateStartStr;
    ResultadoStore.obs.date_end   = dateEndStr;
    ResultadoStore.obs.date_referencia = start.format("MM/YYYY");
  };

  handleFilterChange = (e: any) => {
    var string = e.target.value;
    this.setState({ filtro: string });
  };

  handleFilterTipoChange = (e: any) => {
    var string = e.target.value;
    this.setState({ tipo: string });
  };

  handleJustificativa = (e: any) => {
    var string = e.target.value;
    this.setState({ justificativa: string });
  };

  handleBuscaClick = async () => {
    this.setState({ list: [] });
    ManifestacoesStore.obs.calcularItems = []

    if (this.obs.selectedEmpresa.razao_social == "") {
      toast.warning('Você precisa selecionar uma empresa para filtrar.', {});
      return
    }

    if ((this.obs.selectedEmpresa.senha_certificado == null && this.obs.selectedEmpresa.uf == "PA")) {
      toast.warning('Essa empresa não possui um certificado digital cadastrado.', {});
      return
    }

    var empresa = this.obs.selectedEmpresa.cnpj;
    var filtro = this.state.filtro;
    var tipo = this.state.tipo;
    var date1 = this.state.date1;
    var date2 = this.state.date2;
    this.setState({ list: [] });

    await ManifestacoesStore.setBusca(empresa, filtro, tipo, date1, date2);

    this.handleScroll();

    this.obs.isContestar = true

  };

  handleViewDay = async () => {

    await ManifestacoesStore.setBuscaDay();

  };

  handleGerarRelatorio = () => {

    if (this.obs.selectedEmpresa.razao_social == "") {
      toast.warning('Por favor, selecione uma empresa e filtre os resultados para gerar o relatório.', {});
      return
    }
    if ((this.obs.selectedEmpresa.senha_certificado == null && this.obs.selectedEmpresa.uf == "PA")) {
      toast.warning('Não foi possível gerar o relatório pois essa empresa não possui um certificado digital cadastrado.', {});
      return
    }

    var empresa = this.obs.selectedEmpresa.cnpj;
    var filtro = this.state.filtro;
    var date1 = this.state.date1;
    var date2 = this.state.date2;
    ManifestacoesStore.handleGerarRelatorioPdf(empresa, date1, date2, filtro);
  }

  handleGerarRelatorioExcel = () => {
    if (this.obs.selectedEmpresa.razao_social == "") {
      toast.warning('Por favor, selecione uma empresa e filtre os resultados para gerar o relatório.', {});
      return
    }
    if ((this.obs.selectedEmpresa.senha_certificado == null && this.obs.selectedEmpresa.uf == "PA")) {
      toast.warning('Não foi possível gerar o relatório pois essa empresa não possui um certificado digital cadastrado.', {});
      return
    }

    var empresa = this.obs.selectedEmpresa.cnpj;
    var filtro = this.state.filtro;
    var date1 = this.state.date1;
    var date2 = this.state.date2;
    ManifestacoesStore.handleGerarRelatorioExcel(empresa, date1, date2, filtro);
  };

  handleConfirmaOperacao = () => {
    this.obs.confirmarAlert = false;
    var data = this.state.list;
    if (data.length < 1) {
      toast.warning('Você precisa selecionar as NFe-s desejadas para manifestar.', {});
    } else {
      ManifestacoesStore.confirm_post(data);
    }
  };

  handleDesconheceOperacao = () => {
    this.obs.desconhecerAlert = false;
    var ids = this.state.list;
    if (ids.length < 1) {
      toast.warning('Você precisa selecionar as NFe-s desejadas para manifestar.', {});
    } else {
      ManifestacoesStore.desconhecer_post(ids);
    }
  };

  handleNaoRealizado = () => {
    var ids = this.state.list;
    if (ids.length > 1) {
      toast.warning('Para manifestar uma operação não realizada, você deve fazer com uma chave de cada vez', {});
    } else if (ids.length < 1) {
      toast.warning('Você precisa selecionar uma chave para poder manifestar.', {});
    } else {
      this.obs.showingxJust = true;
    }
  };

  handleViewSefaz = () => {
    this.obs.showingSEFAZ = true;
  };

  handleViewErros = () => {
    AppStore.setLocation("/erros-download");
  };

  handleConfirmarAlert = () => {
    this.obs.confirmarAlert = true;
  };

  handleDesconhecerAlert = () => {
    this.obs.desconhecerAlert = true;
  };

  cancelarSEFAZ = () => {
    this.obs.showingSEFAZ = false;
  };

  confirmarOperacao = async () => {
    this.obs.showingxJust = false;
    var ids = this.state.list;
    var justificativa = this.state.justificativa;

    let data = {
      ids: ids,
      xJust: justificativa
    }
    let resp = await api.post("/api/operacao-nao-realizada-list", data)

    if (resp.data == "ok") {
      toast.success("NFe-s manifestadas com sucesso!", {});
      window.location.reload();

    } else {

      toast.error("Não foi possível manifestar, por favor tente novamente mais tarde.", {});

    }

  };

  cancelarOperacao = () => {
    this.obs.showingxJust = false;
    this.obs.showingEmail = false;
    this.obs.desconhecerAlert = false;
    this.obs.confirmarAlert = false;
    this.obs.confirmarDanfe = false;
  };

  handleSetMail = (e: any) => {
    var string = e.target.value;
    this.setState({ email: string });
  };

  handleTipoArquivo = (e: any) => {
    this.setState({ tipo_arquivo: e.target.value });
  };

  handleScroll = () => {
    window.scrollTo(350, 350);
  };

  onSelectAll = (isSelect, rows) => {
    this.obs.erros_chaves = []

    if (isSelect) {
      let data = rows?.map(value => {
        if (!value.items.download) {
          this.obs.erros_chaves.push(value.chave)
        }
        return {
          id: value.items.id,
          download: value.items.download
        }
      })
      ManifestacoesStore.setCalcularItemsList(data);
    } else {
      ManifestacoesStore.resetCalcularItems();
    }

    this.handleCheckAllChange(isSelect, rows);
  };

  onSelect = (row, checked) => {

    this.validaSitnfe(row)

    if (!row.items.download) {
      toast.warning('Item não disponível para Calcular, pois o Download ainda não está Disponível, tente novamente mais tarde', {});
      return ManifestacoesStore.deleteByIdCalcularItems(row.items.id);
    } else {
      let data = {
        id: row.items.id,
        download: row.items.download
      }

      if (checked) {
        ManifestacoesStore.setCalcularItems(data);
      } else {
        ManifestacoesStore.deleteByIdCalcularItems(row.items.id);
      }
    }
  };

  onCloseErros() {
    this.obs.isOpenErros = false
    this.obs.erros_chaves = []
  }

  validaSitnfe(row) {
    if (row.sitnfe != "3" || row.sitnfe != "2" || !row.desconhecido || !row.nao_realizado) {
      this.handleCheckChange(row.chave, row.cnpj_destino, row.dhemi);
    }
  }

  createCustomSearchField = (props) => {
    return (
      <SearchField
        className="input-filter"
        defaultValue={props.defaultSearch}
        placeholder="Filtrar (Chave, Nº, Valor)"
      />
    );
  };

  closeTour = () => {
    this.obs.isTourOpen = false;
  };

  openTour = () => {
    this.obs.testeGestaoNFes = false;
    this.obs.isTourOpen = true;
  };

  renderShowsTotal(start, to, total) {
    return (
      <p style={{ marginLeft: 12 }}>
        Mostrando {start} a {to} de {total} resultados.&nbsp;&nbsp;
      </p>
    );
  }

  renderNoData() {
    return (
      <div style={{ textAlign: "center" }}>

        Aguarde... &nbsp; &nbsp; &nbsp;

        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  handleCalcular() {

    if (!this.obs.selectedEmpresa) {
      toast.warning('Você precisa selecionar uma empresa para Calcular', {});
      return
    }

    var cnpj_destino = this.obs.selectedEmpresa.cnpj;
    var dhemi_start = this.state.date1;
    var dhemi_end = this.state.date2;
    var ids = ManifestacoesStore.obs.calcularItems;
    var modelo = this.state.tipo;
    var tipo = "entrada";

    ManifestacoesStore.create_manifestacao_task(cnpj_destino, dhemi_start, dhemi_end, ids, modelo, tipo)

    if (this.obs.erros_chaves.length > 0) {
      this.obs.isOpenErros = true;
    }
  }

  render() {
    let niveis_acesso = AppStore.obs1.usuario
      ? AppStore.obs1.usuario.niveis_acesso
      : [""];

    let working = 0 < 100 || 0 < 100;
    let statusText = "Trabalhando...";
    let pct = 100;

    if (ManifestacoesStore.obs.statusManifestacao == "confirmando") {
      statusText = `Manifestando a confirmação`;
    } else if (ManifestacoesStore.obs.statusManifestacao == "desconhecendo") {
      statusText = `Manifestando o desconhecimento`;
    } else if (ManifestacoesStore.obs.statusManifestacao == "download") {
      statusText = `Efetuando Download...`;
    } else {
      statusText = "Efetuando cancelamento";
    }

    const handleBuscaDanfe = (row) => {
      this.obs.filtro_notas.empresa = this.obs.selectedEmpresa.razao_social != ""
        ? this.obs.selectedEmpresa.cnpj
        : row.cnpj_destino;
      this.obs.filtro_notas.data1 = this.state.date1;
      this.obs.filtro_notas.data2 = this.state.date2;
      this.obs.filtro_notas.tipo = this.state.tipo.toUpperCase();
      this.obs.filtro_notas.filtro = "Entrada";
      this.obs.filtro_notas.ids = row.id.split(",");

      return ManifestacoesStore.buscaDanfe(row.chave, this.obs.filtro_notas);
    };

    function statusFormatter(cell, row) {

      if (row.sitnfe) {
        if (row.sitnfe == "1") {
          if (row.confirmado == true) {
            return (
              <Tag
                className="tagConfirmacao"
                style={{ width: "100%", textAlign: "center" }}
              >
                <Icon icon="confirm" /> Conf
              </Tag>
            );
          } else if (row.desconhecido == true) {
            return (
              <Tag
                className="tagDesconhecimento"
                style={{ width: "100%", textAlign: "center" }}
              >
                <Icon icon="help" /> Desc
              </Tag>
            );
          } else if (row.nao_realizado == true) {
            return (
              <Tag
                className="tagNaoRealizada"
                style={{ width: "100%", textAlign: "center" }}
              >
                <Icon icon="cross" /> NRea
              </Tag>
            );
          } else if (row.sitnfe == "3") {
            return (
              <Tag
                className="tagCancelada"
                style={{ width: "100%", textAlign: "center" }}
              >
                <Icon icon="cross" /> Canc
              </Tag>
            );
          } else if (row.sitnfe == "2") {
            return (
              <Tag
                className="tagDenegada"
                style={{ width: "100%", textAlign: "center" }}
              >
                <Icon icon="cross" /> Dene
              </Tag>
            );
          } else if (row.ciencia) {
            return (
              <Tag
                className="tagDenegada"
                style={{ width: "100%", textAlign: "center" }}
              >
                <Icon icon="tick" /> Ciên
              </Tag>
            );
          } else {
            return (
              <Tag
                className="tagCiencia"
                style={{ width: "100%", textAlign: "center" }}
              >
                <Icon icon="time" /> Ciên
              </Tag>
            );
          }
        } else {
          return (
            <Tag
              className="tagCancelada"
              style={{ width: "100%", textAlign: "center" }}
            >
              <Icon icon="cross" /> Canc
            </Tag>
          );
        }
      }
    }

    function calculadoFormatter(cell, row) {
      if (ManifestacoesStore.obs.itens_calculando.indexOf(row.id) != -1) {
        return (
          <Tooltip
            content={"Calculando"}
          >
            <img src="/images/icone-relogio.png" width={22} />
          </Tooltip>
        )
      }
      if (row.calc) {
        return (
          <Tooltip
            content={"Calculado"}
          >
            <img src="/images/contestado.png" width={22} />
          </Tooltip>
        )
      }

      return (
        <Tooltip
          content={"Item não Calculado"}
        >
          <img src="/images/contestar.png" width={22} />
        </Tooltip>
      )
    }

    function danfeFormatter(cell, row) {
      let danfeFormatter = <></>;
      if (row.sitnfe == undefined) {
        danfeFormatter = (
          <img
            src="/images/danfe_icon.svg"
            width={25}
            onClick={() => handleBuscaDanfe(row)}
            style={{ cursor: "pointer", display: "inline-block" }}
          />
        );
      } else if (row.sitnfe == "1" && row.download) {
        danfeFormatter = (
          <img
            src="/images/danfe_icon.svg"
            width={25}
            onClick={() => handleBuscaDanfe(row)}
            style={{ cursor: "pointer", display: "inline-block" }}
          />
        );
      } else {
        danfeFormatter = <></>;
      }
      return danfeFormatter;
    }

    function copyChave(token: string) {
      copyToClipboard(token);
      toast.success('Chave de Acesso Copiada', {});
    }

    function copyChaveFormatter(cell, row) {
      let danfeFormatter = <></>;
      danfeFormatter = (
        <span onClick={() => copyChave(row.chave)}>{row.chave}</span>
      );
      return danfeFormatter;
    }

    function razaoSocialFormatter(cell, row) {
      let rs = row.razao_social.length;

      let danfeFormatter = <></>;
      danfeFormatter = (
        <Tooltip content={row.razao_social}>
          <span>
            {rs > 30
              ? row.razao_social.substring(0, 30) + "..."
              : row.razao_social}
          </span>
        </Tooltip>
      );

      return danfeFormatter;
    }

    const selectRowProp = {
      mode: "checkbox",
      clickToSelect: false,
      onSelectAll: this.onSelectAll,
      columnWidth: "40px",
      onSelect: this.onSelect,
      bgColor: "rgba(27, 98, 111, 0.1)",
      selected: ManifestacoesStore.obs.calcularItems?.map(value => value.id),
      unselectable: ManifestacoesStore.obs.itens_calculando,
    };
    let items = ManifestacoesStore.getPage(ManifestacoesStore.obs.currentPage)?.map((imp: IHistoricoNotas) => {
      return (
        {
          id: imp.id,
          download: imp.download,
          dhemi: imp.dhemi,
          cipher_id: imp.id,
          confirmado: imp.confirmado,
          desconhecido: imp.desconhecido,
          nao_realizado: imp.nao_realizado,
          sitnfe: imp.sitnfe,
          chave: imp.chave.substring(0, 44),
          n_nfe: imp.nnf,
          razao_social: imp.nome,
          cnpj_origem: imp.cnpj_origem ? imp.cnpj_origem.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5",) : "",
          data_emissao: moment(imp.dhemi).add(3, "hours").format("DD/MM/YY") + " às " + moment(imp.dhemi).add(3, "hours").format("HH:mm"),
          valor: "R$ " + numeral(imp.valor).format("0,0.00"),
          cnpj_destino: imp.cnpj_destino,
          items: imp,
          calc: imp.calc,
          ciencia: imp.ciencia
        }
      );
    });

    let empresaText = this.obs.selectedEmpresa.razao_social != ""
      ? `${this.obs.selectedEmpresa.razao_social.substring(0, 35)}... (${formatCnpj(this.obs.selectedEmpresa.cnpj)
      })`
      : "Selecione uma empresa";
    const options = {
      page: 1, // which page you want to show as default
      sizePerPageList: [{
        text: "20",
        value: 20,
      }, {
        text: "50",
        value: 50,
      }, {
        text: "100",
        value: 100,
      }], // you can change the dropdown list for size per page
      sizePerPage: 20, // which size per page you want to locate as default
      pageStartIndex: 1, // where to start counting the pages
      paginationSize: 4, // the pagination bar size.
      prePage: "Ante", // Previous page button text
      nextPage: "Próxima", // Next page button text
      firstPage: "Início", // First page button text
      lastPage: "Última", // Last page button text
      paginationShowsTotal: this.renderShowsTotal, // Accept bool or function
      paginationPosition: "bottom", // default is bottom, top and both is all available
      // hideSizePerPage: true > You can hide the dropdown for sizePerPage
      // alwaysShowAllBtns: true // Always show next and previous button
      // withFirstAndLast: false > Hide the going to First and Last page button
      searchField: this.createCustomSearchField,
    };

    let chaves = this.obs.erros_chaves?.map(value => {
      return (<p>{value}</p>)
    })

    return (
      <div>
        <Tour
          onRequestClose={this.closeTour}
          steps={tourConfig}
          isOpen={this.obs.isTourOpen}
          maskClassName="mask"
          className="helper"
          rounded={5}
        />

        <LoadingModal open={ManifestacoesStore.obs.buscando} onClose={() => ManifestacoesStore.obs.buscando = false} title={"Gerando DANFE"} />

        <Alert
          confirmButtonText="Quero Conhecer o Módulo"
          cancelButtonText="Fechar"
          intent="primary"
          isOpen={this.obs.testeGestaoNFes}
          onCancel={() => this.obs.testeGestaoNFes = false}
          onConfirm={() => this.openTour()}
          className="modalNotifyAdm"
        >
          <MDBRow>
            <MDBCol md="5" className="image-provider image-bem-vindo">
              <video className="videoTag" autoPlay loop muted>
                <source src="/images/bem-vindo.mp4" type="video/mp4" />
              </video>
            </MDBCol>
            <MDBCol
              md="6"
              className="offset-md-1 content-modal-notify content-modal-bem-vindo"
            >
              <h2 className="title">Gestão NF-es</h2>
              <p style={{ display: "block", paddingRight: 50 }}>
                Neste módulo, você poderá arquivar e realizar as manifestações
                de todas as NF-es emitidas para um CNPJ. Esta função se habilita
                no momento em que você cadastra o certificado digital da
                empresa.
              </p>
              <p style={{ display: "block", paddingRight: 50, marginBottom: -15 }}>
                <b>
                  Obs: Disponibilizamos a Gestão NF-es somente para contas com
                  assinatura.
                </b>
              </p>
              <MDBRow className="rowNotify" style={{ marginBottom: -15 }}>
                <MDBCol md="1">
                  <img src="/images/safety.svg" width={30} />
                </MDBCol>
                <MDBCol md="10">
                  <p className="item-notify">Manifeste as NF-es</p>
                  <p>
                    Com o FIPO, em apenas 1 clique o usuário consegue Manifestar
                    as NF-es.
                  </p>
                </MDBCol>
              </MDBRow>
              <MDBRow className="rowNotify" style={{ marginBottom: -15 }}>
                <MDBCol md="1">
                  <img src="/images/process.svg" width={30} />
                </MDBCol>
                <MDBCol md="10">
                  <p className="item-notify">Armazene os XMLs e gere DANFEs</p>
                  <p>
                    Ao efetuar sua assinatura, você terá 2gb disponíveis para
                    poder armazenar os XMLs. Além de poder realizar o download
                    de forma muito prática.
                  </p>
                </MDBCol>
              </MDBRow>
              <MDBRow className="rowNotify" style={{ marginBottom: -15 }}>
                <MDBCol md="1">
                  <img src="/images/notification_action.svg" width={30} />
                </MDBCol>
                <MDBCol md="10">
                  <p className="item-notify">Alertas para Downloads</p>
                  <p>
                    Em alguns momentos, enfrentamos instabilidades vindas
                    diretamente dos webservices da SEFAZ, mas não se preocupe,
                    avisaremos você caso haja downloads de XMLs pendentes.
                  </p>
                </MDBCol>
              </MDBRow>
              <MDBRow className="rowNotify">
                <MDBCol md="1">
                  <img src="/images/accept.svg" width={30} />
                </MDBCol>
                <MDBCol md="10">
                  <p className="item-notify">Buscas e Informações ágeis</p>
                  <p>
                    Ao cadastrar o certificado digital da empresa, dentro de
                    instantes a FIPO já realiza a busca dos dados na SEFAZ,
                    organizando eles para você poder ter acesso a todas as
                    informações.
                  </p>
                </MDBCol>
              </MDBRow>
            </MDBCol>
          </MDBRow>
        </Alert>

        <LoadingModal open={ManifestacoesStore.obs.progressDownload} onClose={() => ManifestacoesStore.obs.progressDownload = false} title={"Baixando arquivo(s)"} />

        <Dialog
          isOpen={ManifestacoesStore.obs.InfoDownload}
          onClose={(e) => ManifestacoesStore.obs.InfoDownload = false}
          title="Download Efetuado"
          style={{ width: 600 }}
        >
          <div className={Classes.DIALOG_BODY}>
            <div style={{ marginBottom: 10 }}>
              <p>
                <b>NF-es Selecionadas:</b> {ManifestacoesStore.obs.InfoDownload1}
              </p>
              <p>
                <b>Downloads:</b> {ManifestacoesStore.obs.InfoDownload2}
              </p>
              <p>
                <b>Erros:</b> {ManifestacoesStore.obs.InfoDownload3}
              </p>
              <p>
                <b>
                  Atenção: não efetuamos o download de{" "}
                  <u>
                    NF-es canceladas ou com manifestação de desconhecimento e
                    não realizado.
                  </u>
                </b>
              </p>
            </div>
          </div>
        </Dialog>

        <Dialog
          isOpen={ManifestacoesStore.obs.InfoDownloadDanfe}
          onClose={(e) => ManifestacoesStore.obs.InfoDownloadDanfe = false}
          title="Download Efetuado"
          style={{ width: 600 }}
        >
          <div className={Classes.DIALOG_BODY}>
            <div style={{ marginBottom: 10 }}>
              <p>
                <b>NF-es Selecionadas:</b> {ManifestacoesStore.obs.InfoDownload1}
              </p>
              <p>
                <b>DANFEs Geradas:</b> {ManifestacoesStore.obs.InfoDownload2}
              </p>
              <p>
                <b>Erros:</b> {ManifestacoesStore.obs.InfoDownload3}
              </p>
              <p>
                <b>
                  Atenção: não efetuamos o download da DANFE de{" "}
                  <u>
                    NF-es canceladas ou com manifestação de desconhecimento e
                    não realizado.
                  </u>
                </b>
              </p>
            </div>
          </div>
        </Dialog>

        <Alert
          confirmButtonText="Confirmar Operação"
          cancelButtonText="Cancelar Operação"
          intent="warning"
          isOpen={this.obs.showingxJust}
          onCancel={() => this.cancelarOperacao()}
          onConfirm={() => this.confirmarOperacao()}
        >
          <p>
            Por favor, informe a justificativa para continuar com a manifestação
            de "Não Realizada".
          </p>
          <FormGroup
            label="Justificativa"
            labelFor="Justificativa"
          >
            <InputGroup
              id="justificativa"
              onChange={this.handleJustificativa}
            />
          </FormGroup>
        </Alert>
        <Alert
          isOpen={this.obs.showingSEFAZ}
          onClose={() => this.cancelarSEFAZ()}
        >
          <h2 className="titleSEFAZ">
            Sincronização de{" "}
            <u>{moment(ManifestacoesStore.obs.hora).format("L")}</u>
          </h2>
          <span className="DadosSEFAZAlert">
            <Tag className="tagCiencia tagAlert">
              <Icon icon="time" />Ciên
            </Tag>{" "}
            Ciência da Operação <b>({ManifestacoesStore.obs.ciencia})</b> <br />
            <br />
            <Tag className="tagConfirmacao tagAlert">
              <Icon icon="confirm" />Conf
            </Tag>{" "}
            Confirmadas <b>({ManifestacoesStore.obs.confirmadas})</b> <br /> <br />
            <Tag className="tagNaoRealizada tagAlert">
              <Icon icon="cross" />NRea
            </Tag>{" "}
            Não Realizadas <b>({ManifestacoesStore.obs.nao_realizadas})</b>
            <br /> <br />
            <Tag className="tagDesconhecimento tagAlert">
              <Icon icon="help" />Desc
            </Tag>{" "}
            Desconhecidas <b>({ManifestacoesStore.obs.desconhecidas})</b> <br />
            {" "}
            <br />
            Intervalo de cada sincronização: <b>30 a 60 min</b>
          </span>
        </Alert>
        <Alert
          confirmButtonText="Confirmar Operação"
          cancelButtonText="Cancelar Operação"
          isOpen={this.obs.confirmarAlert}
          onClose={() => this.cancelarOperacao()}
          onConfirm={() => this.handleConfirmaOperacao()}
        >
          <h2 className="titleSEFAZ">Confirmar Operações?</h2>
          <p>
            Você deseja realmente <b>confirmar</b> as NF-es selecionadas?
          </p>
        </Alert>
        <Alert
          confirmButtonText="Ok"
          cancelButtonText="Cancelar Operação"
          isOpen={this.obs.confirmarDanfe}
          onClose={() => this.cancelarOperacao()}
          onConfirm={() => this.cancelarOperacao()}
        >
          <h2 className="titleSEFAZ">Observação</h2>
          <p>Você só poderá gerar a DANFE de notas que estejam confirmadas.</p>
          <p>Aguarde em quanto efetuamos o download.</p>
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </Alert>
        <Alert
          confirmButtonText="Desconhecer Operação"
          cancelButtonText="Cancelar Operação"
          isOpen={this.obs.desconhecerAlert}
          onClose={() => this.cancelarOperacao()}
          onConfirm={() => this.handleDesconheceOperacao()}
        >
          <h2 className="titleSEFAZ">Desconhecer Operações?</h2>
          <p>
            Você deseja realmente <b>desconhecer</b> as NF-es selecionadas?
          </p>
        </Alert>
        <Dialog
          isOpen={ManifestacoesStore.obs.confirmando}
          title="Manifestações"
          style={{ width: 600 }}
        >
          <div className={Classes.DIALOG_BODY}>
            <div style={{ marginBottom: 10 }}>{statusText}</div>
            <ProgressBar
              value={pct}
              intent="primary"
              animate={working}
              stripes={working}
            />
          </div>
        </Dialog>

        <Alert
          confirmButtonText="Fechar"
          isOpen={this.obs.isOpenErros}
          onClose={() => this.onCloseErros()}
          onConfirm={() => this.onCloseErros()}
        >
          <h2 className="titleSEFAZ">Chaves não Calculadas</h2>
          <p><b>Nâo foi possível Calcular as Chaves abaixo, pois o Download do Arquivo ainda não está Disponível!</b></p>
          <div className="errosChaves">
            {chaves}
          </div>
        </Alert>
        <MDBRow>
          <MDBCol
            xl="6"
            lg="6"
            md="6"
            sm="6"
            xs="12"
            // className="dadosGeraisSefaz"
            data-tut="periodo"
          >
            <MDBRow>
              <MDBCol xl="9" lg="9" md="9" sm="9" xs="12">
                <FormGroup label="Empresa" className="empresaSelect">
                  <EmpresaSelect
                    items={EmpresaStore.sortedEmpresas}
                    itemRenderer={renderEmpresa}
                    itemPredicate={filterEmpresa}
                    onItemSelect={(e: IEmpresa) => this.obs.selectedEmpresa = e}
                    inputProps={{ placeholder: "Filtrar uma empresa" }}
                  >
                    <Button
                      text={empresaText}
                      rightIcon="double-caret-vertical"
                      alignText={Alignment.LEFT}
                    />
                  </EmpresaSelect>
                </FormGroup>
              </MDBCol>
              <MDBCol xl="3" lg="3" md="3" sm="3" xs="12">
                <FormGroup
                  label="Tipo"
                  className="nz-horizontal-field selectFullWidth"
                >
                  <select
                    onChange={this.handleFilterTipoChange}
                    className="bp3-button bp3-align-left"
                  >
                    <option key="NF-e">NF-e</option>
                    <option key="CT-e">CT-e</option>
                  </select>
                </FormGroup>
              </MDBCol>
              <MDBCol xl="4" lg="4" md="4" sm="4" xs="12">
                <FormGroup
                  label="Status das Notas"
                  className="nz-horizontal-field selectFullWidth"
                >
                  <select
                    onChange={this.handleFilterChange}
                    className="bp3-button bp3-align-left"
                  >
                    <option key="Todos">Todos</option>
                    <option key="Ciência">Ciência da Operação</option>
                    <option key="Confirmado">Confirmação da Operação</option>
                    <option key="Desconhecido">
                      Desconhecimento da Operação
                    </option>
                    <option key="Não Realizado">Operação não Realizada</option>
                    <option key="Canceladas">Canceladas</option>
                    <option key="Denegadas">Denegadas</option>
                  </select>
                </FormGroup>
              </MDBCol>
              <MDBCol md="6">
                <FormGroup
                  label="Período de Emissão"
                  className="inputsPeriodoCalculos"
                >
                  <DateRangePicker
                    onChange={this.handleDateChange}
                    value={this.obs.selectedPeriod}
                  />
                </FormGroup>
              </MDBCol>
              <MDBCol md="2">
                <MDBBtn
                  className="btnDefault btnBuscarNfe mt25"
                  onClick={this.handleBuscaClick}
                  disabled={niveis_acesso.indexOf("h1") == -1}
                >
                  Buscar
                </MDBBtn>
              </MDBCol>
            </MDBRow>
          </MDBCol>
            <MDBCol
              xl="3"
              lg="3"
              md="3"
              sm="3"
              xs="12"
              className="dadosGeraisSefaz offset-md-1 offset-sm-1"
              data-tut="sincronizacoes"
            >
              <h2 className="titleSEFAZ titleSincro">
                Sincronizações de <u>{moment().format("L")}</u>
              </h2>
              <span className="DadosSEFAZAlert">
                <MDBRow>
                  <MDBCol
                    xl="6"
                    lg="6"
                    md="6"
                    sm="6"
                    xs="12"
                    onClick={this.handleViewDay}
                    className="cursor-pointer"
                  >
                    <Tag className="tagCiencia tagAlert">
                      <Icon icon="time" />
                    </Tag>{" "}
                    Ciência <b>({ManifestacoesStore.obs.ciencia})</b> <br />
                    <Tag className="tagConfirmacao tagAlert">
                      <Icon icon="confirm" />
                    </Tag>{" "}
                    Confir. <b>({ManifestacoesStore.obs.confirmadas})</b>{" "}
                    <br />
                  </MDBCol>
                  <MDBCol
                    xl="6"
                    lg="6"
                    md="6"
                    sm="6"
                    xs="12"
                    onClick={this.handleViewDay}
                    className="cursor-pointer"
                  >
                    <Tag className="tagNaoRealizada tagAlert">
                      <Icon icon="cross" />
                    </Tag>{" "}
                    Não Reali. <b>({ManifestacoesStore.obs.nao_realizadas})</b>
                    {" "}
                    <br />
                    <Tag className="tagDesconhecimento tagAlert">
                      <Icon icon="help" />
                    </Tag>{" "}
                    Descon. <b>({ManifestacoesStore.obs.desconhecidas})</b>
                    {" "}
                    <br />
                  </MDBCol>
                </MDBRow>
                Intervalo de cada sincronização: <b>30 a 60 min &nbsp;</b>
                <div className="spinner-border" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </span>
            </MDBCol>
            <MDBCol
              xl="2"
              lg="2"
              md="2"
              sm="2"
              xs="12"
              className="dadosGeraisSefaz"
              data-tut="download"
            >
              <h2 className="titleSEFAZ titleSincro">
                Downloads Pendentes
              </h2>
              <span className="DadosSEFAZAlert">
                <MDBRow>
                  <MDBCol
                    xl="12"
                    lg="12"
                    md="12"
                    sm="12"
                    xs="12"
                    onClick={this.handleViewErros}
                    className="cursor-pointer"
                  >
                    <Tag className="tagConfirmacao tagAlert tagErroDownload">
                      <Icon icon="download" />
                    </Tag>{" "}
                    NF-es <b>({ManifestacoesStore.obs.totalErros})</b>
                    {ManifestacoesStore.obs.totalErros >= 1 &&
                      <div className="blob"></div>}
                  </MDBCol>
                </MDBRow>
              </span>
            </MDBCol>
        </MDBRow>
        <MDBRow className="btns-Manifestacoes">
          <MDBCol xl="12" lg="12" md="12" sm="12" xs="12" className="btns-Drop" data-tut="manifestacao">
            {this.obs.selectedEmpresa?.uf == "PA" && this.obs.isContestar &&
              <div className="btnCalcularWidth">
                <Popover popoverClassName={Classes.POPOVER_CONTENT_SIZING}>
                  <Tooltip
                    content={`Calcular ${ManifestacoesStore.obs.calcularItems.length}`}
                    disabled={ManifestacoesStore.obs.calcularItems.length == 0}
                  >
                    <Button
                      disabled={ManifestacoesStore.obs.calcularItems.length == 0}
                      icon="issue"
                    >
                      Calcular Selecionados
                    </Button>
                  </Tooltip>
                  <div>
                    <H5>Calcular?</H5>
                    <p>Antes de Calcular, confirme se as notas estão corretas!</p>
                    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 15, }}>

                      <Button className={Classes.POPOVER_DISMISS} style={{ marginRight: 10 }}>
                        Cancelar
                      </Button>

                      <Button intent="danger" className={Classes.POPOVER_DISMISS} onClick={() => this.handleCalcular()}>
                        Calcular
                      </Button>
                    </div>
                  </div>
                </Popover>
              </div>
            }

            <MDBDropdown className="dropdown-manifestar">
              <MDBDropdownToggle
                caret
                className="btnDefault btnManifestar"
                disabled={niveis_acesso.indexOf("h2") == -1}
              >
                Manifestar
              </MDBDropdownToggle>
              <MDBDropdownMenu basic>
                <MDBDropdownItem
                  onClick={this.handleConfirmarAlert}
                  className="actionMani"
                >
                  <Tag className="tagConfirmacao tagAlert">
                    <Icon icon="confirm" />Conf
                  </Tag>{" "}
                  Confirmar Operação
                </MDBDropdownItem>
                <MDBDropdownItem
                  onClick={this.handleDesconhecerAlert}
                  className="actionMani"
                >
                  <Tag className="tagDesconhecimento tagAlert">
                    <Icon icon="help" />Desc
                  </Tag>{" "}
                  Desconhecer Operação
                </MDBDropdownItem>
                <MDBDropdownItem
                  onClick={this.handleNaoRealizado}
                  className="actionMani"
                >
                  <Tag className="tagNaoRealizada tagAlert">
                    <Icon icon="cross" />NRea
                  </Tag>{" "}
                  Operação não Realizada
                </MDBDropdownItem>
              </MDBDropdownMenu>
            </MDBDropdown>
            <MDBBtn
              className="btnDefault btnManifestar"
              onClick={this.handleGerarRelatorioExcel}
              style={{ marginRight: 20 }}
            >
              Exportar Excel
            </MDBBtn>
            <MDBBtn
              className="btnDefault btnManifestar"
              onClick={this.handleGerarRelatorio}
              style={{ marginRight: 20 }}
            >
              Exportar PDF
            </MDBBtn>
          </MDBCol>
        </MDBRow>

        <div data-tut="table">
          <BootstrapTable
            className="TableDefault"
            ref="table"
            data={items}
            selectRow={selectRowProp}
            pagination={true}
            options={options}
            hover
            search
            data-tut="table"
          >
            <TableHeaderColumn dataField="id" hidden width="1%">
              #
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="cipher_id"
              isKey={true}
              hidden
              width="1%"
            >
              #
            </TableHeaderColumn>
            <TableHeaderColumn dataField="confirmado" hidden width="1%">
              #
            </TableHeaderColumn>
            <TableHeaderColumn dataField="desconhecido" hidden width="1%">
              #
            </TableHeaderColumn>
            <TableHeaderColumn dataField="nao_realizado" hidden width="1%">
              #
            </TableHeaderColumn>
            <TableHeaderColumn dataField="sitnfe" hidden width="1%">
              #
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="chave"
              dataFormat={copyChaveFormatter}
              width="25%"
            >
              Chave (Clique para Copiar)
            </TableHeaderColumn>
            <TableHeaderColumn dataField="n_nfe" width="10%">
              Nº NF-e
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="razao_social"
              dataFormat={razaoSocialFormatter}
              width="20%"
            >
              Emitente
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="cnpj_origem"
              width="10%"
            >
              CNPJ/CPF
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="data_emissao"
              width="10%"
            >
              Emissão
            </TableHeaderColumn>
            <TableHeaderColumn dataField="valor" width="10%">
              Valor
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="danfe"
              dataFormat={danfeFormatter}
              width="8%"
            >
              Ver NF-e
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="razao_social"
              dataFormat={statusFormatter}
              width="8%"
            >
              Status
            </TableHeaderColumn>
            {this.obs.isContestar && <TableHeaderColumn
              dataFormat={calculadoFormatter}
              width="8%"
            >
              Calcular
            </TableHeaderColumn>}
          </BootstrapTable>
        </div>
      </div>
    );
  }
}

const tourConfig = [
  {
    selector: "[data-tut=\"periodo\"]",
    content:
      `Selecione a empresa, o período e o status das NF-es que você quer filtrar.`,
  },
  {
    selector: "[data-tut=\"sincronizacoes\"]",
    content:
      `Aqui você poderá acompanhar as sincronizações diárias das NF-es de todos os certificados cadastrados.`,
  },
  {
    selector: "[data-tut=\"download\"]",
    content: `Caso haja algum download do XML pendente, você será informado.`,
  },
  {
    selector: "[data-tut=\"manifestacao\"]",
    content:
      `Manifeste suas NF-es e efetue o download de XMLs e DANFEs vinculados ao seu CNPJ.`,
  },
  {
    selector: "[data-tut=\"table\"]",
    content:
      `Todas as informações das NF-es estarão disponíveis nessa tabela. Basta selecionar uma ou um lote de chaves e efetuar a ação desejada.`,
  },
];